import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PreApprovalWidget from '../components/PreApprovalWidget';

const PreApprovalPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Get Pre-Approved for Equipment Financing | EquipEASE</title>
        <meta name="description" content="Get pre-approved for equipment financing in minutes. No credit check required. EquipEASE offers competitive rates for construction, medical, agricultural, and transportation equipment." />
        <link rel="canonical" href="https://equipease.ca/get-preapproved" />
      </Helmet>

      <Header />

      <main className="flex-1 py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#333333] mb-4">
              Get Pre-Approved for Financing
            </h1>
            <p className="text-lg text-[#4A4A4A] max-w-2xl mx-auto">
              Complete the quick form below and a financing specialist will contact you within 2 business hours with your estimated rates. No credit check required.
            </p>
          </div>
          <PreApprovalWidget />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PreApprovalPage;
